import Header from './components/Header';
import Hero from './components/Hero';

function App() {
  return (<>
  <Header />
  <Hero />
  </>);
}

export default App;
